import { combineTokens, makeSelectors } from '@utils/css';

const transitionDurationMs = {
  enter: 150,
  exit: 100
};
const dropdownTokens = combineTokens("--dropdown", {
  zIndex: "100011"
});
const dropdownWrapper = "dibdozyzxq";
const dropdown = "dibdy65jj4";
const dropdownBackdrop = "dibd1k0unby";
const selectors = makeSelectors({
  content: dropdown,
  backdrop: dropdownBackdrop
});

export { dropdown, dropdownBackdrop, dropdownTokens, dropdownWrapper, selectors, transitionDurationMs };
import "./dropdown.style.linaria.module.css";
//# sourceMappingURL=dropdown.style.js.map
